import { MESSAGE_TYPE_WARNING } from '../global-constants'
import { Html5Entities } from 'html-entities';
import { t } from 'i18next';

const htmlEntities = new Html5Entities();

// Decode HTML entities in the 'name' field
export function cleanListEntities(list) {
	Object.keys(list).map(function(key, index) {
		let listDetails = list[key];
		if (listDetails.name) {
			list[key] = { ...listDetails, name: htmlEntities.decode(listDetails.name) };
		}
	});

	return list;
}

export function checkForDuplicate(allLists, newName, setBanner) {
	if (allLists.some(x => x.name.trim().toLowerCase() == newName.trim().toLowerCase())) {
		setBanner(t('ERROR_LIST_NAME_EXISTS'), MESSAGE_TYPE_WARNING);
		return false;
	} else {
		return true;
	}
}

export function renameIfDuplicate(allLists, newName) {
	let copyName = [newName, ' - Copy'].join('');
	while (allLists.some(x => x.name.trim().toLowerCase() == `${copyName}`.trim().toLowerCase())) {
		copyName = [copyName, ' - Copy'].join('');
	}
	return copyName;
}

export function sanitizeFilename(text = '') {
	// Replace non-alphanumeric characters with underscores
	return text.replace(/[^a-z0-9]/gi, '_').toLowerCase();
}

export function sanitizeCsvValue(text = '') {
	// Replace quotation marks and quote value
	return `"${text.replace(/"/g, '""')}"`;
}

export function forceDownload(fileName, fileData = '', mediaType = 'text/csv', charset = 'utf-8') {
	// Force the browser to download data as a file
	if (fileName) {
		const hiddenElement = document.createElement('a');
		hiddenElement.href = `data:${mediaType};charset=${charset},${encodeURIComponent(fileData)}`;
		hiddenElement.download = fileName;
		hiddenElement.target = '_blank';
		hiddenElement.click();
	}
}

export function exportableDistList(id = '', name = '', distList = [], accounts = {}) {
	// Build a CSV file from distribution list data

	// First row: name, value
	let heading = `${sanitizeCsvValue(name)},${sanitizeCsvValue(id)}\n\n`;

	// Account rows: account ID, account name
	const accountRows = distList.map((accountId) => {
		return `${sanitizeCsvValue(accountId)},${sanitizeCsvValue(htmlEntities.decode(accounts[accountId]))}`;
	}).join('\n');

	return `${heading}${accountRows}`;
}

export function buildAccounts(tree) {
	// Recursively traverse tree and build list of { account_ID: account_name, ... }
	let accounts = { [tree.value.id]: tree.value.name };

	if (tree.children && tree.children.length) {
		tree.children.forEach(child => {
			accounts = { ...accounts, ...buildAccounts(child) };
		});
	}

	return accounts;
}
